module.exports = "/_next/static/images/6dce66004b1f5325f3e58f2aa3462017-guy-xs.jpg";